var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1526_2514)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1526_2514)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.00034,
    y: 5.00017,
    width: 15,
    height: 20,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4063 19.9998C10.0794 19.9998 9.83149 19.7049 9.88774 19.3829L11.4504 10.4357C11.4944 10.1837 11.7131 9.99983 11.9689 9.99983C12.2959 9.99983 12.5437 10.2947 12.4875 10.6168L10.9249 19.564C10.8809 19.816 10.6621 19.9998 10.4063 19.9998ZM12.9478 19.9998C12.6209 19.9998 12.373 19.7049 12.4293 19.3829L13.9919 10.4357C14.0359 10.1837 14.2547 9.99983 14.5105 9.99983C14.8374 9.99983 15.0853 10.2947 15.029 10.6168L13.4664 19.564C13.4224 19.816 13.2036 19.9998 12.9478 19.9998ZM16.0231 13.3893C16.0231 13.6832 15.7848 13.9215 15.4908 13.9215H9.77789C9.48392 13.9215 9.24561 13.6832 9.24561 13.3893C9.24561 13.0953 9.48392 12.857 9.77789 12.857H15.4908C15.7848 12.857 16.0231 13.0953 16.0231 13.3893ZM15.5343 16.6516C15.5343 16.9456 15.296 17.1839 15.002 17.1839H9.28262C8.98865 17.1839 8.75034 16.9456 8.75034 16.6516C8.75034 16.3576 8.98865 16.1193 9.28262 16.1193H15.002C15.296 16.1193 15.5343 16.3576 15.5343 16.6516Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25052 1.62514L18.7501 1.63764C19.9205 1.63764 20.8755 2.58468 20.8755 3.75014V26.2501C20.8755 27.418 19.9184 28.3751 18.7505 28.3751H6.25052C5.08506 28.3751 4.13802 27.4205 4.13802 26.2501V3.75014C4.13802 2.57985 5.08515 1.62523 6.25052 1.62514ZM5.87552 24.1251H19.1255V5.87514H5.87552V24.1251Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 23.7502,
    cy: 21.2498,
    r: 7.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6222 16.25V18.6506H22.7812V20.571H26.6222V22.9716L29.983 19.6108L26.6222 16.25ZM20.8608 20.0909L17.5 23.4517L20.8608 26.8125V24.4119H24.7017V22.4915H20.8608V20.0909Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1526_2514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1526_2514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(-2.49983)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortability);
export default __webpack_public_path__ + "static/media/portability.5137e8e68af3af2a6ab80a799b52a0f1.svg";
export { ForwardRef as ReactComponent };